import React from 'react';

import CommonDataGrid from '../../../../../components/CommonDataGrid';
import { Column } from '../../../../../components/CommonDataGrid/props';
import Loader from '../../../../../components/Loader';
import Modal from '../../../../../components/Model';
import { formatDate, formatTime, styles } from '../../../../../util/constant';
import useLeave from '../useLeave';

const Leave: React.FC = () => {

  const {
    leaveData,
    showConfirmation,
    handleCancelStatusUp,
    setSearch,
    setPage,
    page,
    loading,
    totalPage,
    handleSelectStatus,
    showModal,
    handleModalClose,
    handleModalSubmit,
    description,
    setDescription,
    handleDateFilter
  } = useLeave();

  const columns: Column[] = [
    {
      field: "userId",
      headerName: "User",
      width: 50,
      align: "center",
      renderCell: (params: any) => <p>{params.value.name}</p>,
    },
    // {
    //   field: "type",
    //   headerName: "Leave Type",
    //   width: 50,
    //   align: "center",
    // },
    // {
    //   field: "subtype",
    //   headerName: "Sub Type",
    //   width: 50,
    //   align: "center",
    // },
    {
      field: "description",
      headerName: "Description",
      width: 50,
      align: "center",
    },
    // {
    //   field: "paidDays",
    //   headerName: "paid Days",
    //   width: 50,
    //   align: "center",
    // },
    // {
    //   field: "unpaidDays",
    //   headerName: "unpaid Days",
    //   width: 50,
    //   align: "center",
    // },
    // {
    //   field: "totalDays",
    //   headerName: "Total Days",
    //   width: 50,
    //   align: "center",
    // },
    {
      field: "fromDate",
      renderCell: (params: any) => <p>{formatDate(params.value)}</p>,
      headerName: "From",
      align: "center",
      width: 50,
    },
    {
      field: "toDate",
      renderCell: (params: any) => <p>{formatDate(params.value)}</p>,
      headerName: "To",
      align: "center",
      width: 50,
    },
    // {
    //   field: "createdAt",
    //   renderCell: (params: any) => <p>{formatDate(params.value)}</p>,
    //   headerName: "Requested Date",
    //   align: "center",
    //   width: 50,
    // },
    // {
    //   field: "createdAt",
    //   renderCell: (params: any) => <p>{formatTime(params.value)}</p>,
    //   headerName: "Requested Time",
    //   align: "center",
    //   width: 50,
    // },
    {
      field: "Actions",
      renderCell: (params: any) => (
        <div className={styles[params.row.status] || "bg-gray-200 "}>
          <select
            defaultValue={params.row.status}
            onChange={(event) => handleSelectStatus(event, params.row)}
            className="appearance-none  bg-transparent outline-none w-full cursor-pointer font-semibold"
          >
            <option value="pending">pending</option>
            <option value="approve">approve</option>
            <option value="reject">reject</option>
          </select>
        </div>
      ),
      headerName: "Status",
      width: 50,
      align: "center",
    },
    // {
    //   field: "comments",
    //   headerName: "Comment",
    //   width: 50,
    //   align: "center",
    // },
  ];

  return (
    <div>
      <div className="h-full overflow-y-auto">
        {loading && <Loader />}
        <div>
          <>
            <CommonDataGrid
              tableName="Leave"
              rows={leaveData}
              columns={columns}
              getRowId={(row) => row._id}
              showConfirmation={showConfirmation}
              confirmationMessage="Are you sure you want to Status Update this Leave?"
              onCancelDelete={handleCancelStatusUp}
              onConfirmDelete={() => {}}
              loading={!leaveData}
              setSearchBar={setSearch}
              setCurrentPage={setPage}
              currentPage={page}
              totalPages={totalPage}
              dayFilter={false}
              searchFilter={false}
              downloadCSVFilter={false}
              onDateFilter={handleDateFilter}
            />
          </>
        </div>
      </div>
      {showModal && (
        <Modal isOpen={showModal} onClose={handleModalClose}>
          <div className="p-4">
            <textarea
              className="w-full p-2 border rounded"
              rows={4}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Enter description..."
            />
            <div className="flex justify-end mt-4 space-x-2">
              <button
                className="px-4 py-2 text-gray-600 border rounded hover:bg-gray-100"
                onClick={handleModalClose}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 text-white bg-blue-600 rounded hover:bg-blue-700"
                onClick={handleModalSubmit}
              >
                Submit
              </button>
            </div>
          </div>
        </Modal>
      )}



    </div>
  );
};

export default Leave;
